import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import cameraIcon from './images/vr-cam-icon.png';
import './VirtualTour.css';

// setAppElement throws an error in tests "react-modal: No elements were found for selector #app."
/* istanbul ignore if */
if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root');

class VirtualTour extends Component {
    state = {
        modalIsOpen: false,
        url: '',
    }

    toggleModal = (i) => this.setState(prevState => ({
        modalIsOpen: !prevState.modalIsOpen,
        url: i,
    }))
    
    render() {
        
        const { vr_background, vr_package } = this.props.property;
        
        return (
            vr_package && vr_package.length > 0 ?
                <div className="property-detail-virtual-tour">
                    <div className="section">
                        <div className="container">
                            <div className="columns">
                                <div className="column is-offset-1-tablet is-10-tablet">
                                    <h3 className="big-title border-left-yellow">
                                        Tour the Building
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section vr-tour-section">
                        <div className="container">
                            <div className="vr-wrapper">
                                <img alt="Property Background" className="vr-background" src={`${process.env.RAZZLE_ASSET_URL}${vr_background}`} />
                                {vr_package.map(({ path, x, y }, i) => {
                                    return (
                                        <button key={i} onClick={() => this.toggleModal(path)} className="vr-link" style={{ left: `${x}`, top: `${y}` }}>
                                            <img loading="lazy" alt="VR Link" className="vr-link-img" src={cameraIcon} />
                                        </button>
                                    );
                                })}
                                {this.state.modalIsOpen && <Modal
                                    className="vr-modal modal-fade"
                                    contentLabel="Modal"
                                    isOpen={this.state.modalIsOpen}
                                    onAfterOpen={this.afterOpenModal}
                                    onRequestClose={this.toggleModal}
                                    overlayClassName="Overlay vr-modal-overlay modal-fade"
                                    shouldCloseOnOverlayClick={true}
                                    shouldCloseOnEsc={true}
                                >
                                    <div className="vr-iframe-wrapper">
                                        <button onClick={this.toggleModal} className="close-button">
                                            <span className='close-text'>CLOSE</span>
                                            <span className='close-times'>&#x2715;</span>
                                        </button>
                                        <iframe className="vr-iframe" title="Virtual Tour" src={`${process.env.RAZZLE_ASSET_URL}${this.state.url}`}/>
                                    </div>
                                </Modal>}
                            </div>
                        </div>
                    </div>
                </div>
                : null
        );
    }
}

VirtualTour.propTypes = {
    property: PropTypes.object.isRequired,
};

export default VirtualTour;
